var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-alert browser-div"},[(_vm.imagesrc)?_c('img',{staticClass:"image",attrs:{"src":_vm.imagesrc,"alt":"image","loading":"lazy"}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }